(function () {
	'use strict';

	class EncasementItemsDialogCtrl {
		constructor($mdDialog, $q, paymentService) {
			this.dialog = $mdDialog;
			this.q = $q;
			this.paymentService = paymentService;
			this.encasement = this.encasement || null;
		}

		static get $inject() {
			return ["$mdDialog", "$q",];
		}

		$onInit() {
		}

		cancel() {
			this.dialog.cancel();
		}
	}

	module.exports = {
		controller: EncasementItemsDialogCtrl,
		template: require("./encasement-items.tpl.html"),
		controllerAs: "vm",
		bindToController: true,
		multiple: true,
		parent: $(document.body),
		clickOutsideToClose: true,
	};
})();


